// import * as exports from '@directives/index';

// All of the Directives should be putted into Directives Array
// Note: don't add the Directive directly in the SharedModule
export const Directives = [
  // exports.DirectiveName
];
